/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `generation` - generation
 * * `perturbation` - perturbation
 * * `prediction` - prediction
 * @export
 */
export const DataJobEnum = {
  generation: 'generation',
  perturbation: 'perturbation',
  prediction: 'prediction',
} as const;
export type DataJobEnum = (typeof DataJobEnum)[keyof typeof DataJobEnum];

export function instanceOfDataJobEnum(value: any): boolean {
  for (const key in DataJobEnum) {
    if (Object.prototype.hasOwnProperty.call(DataJobEnum, key)) {
      if ((DataJobEnum as Record<string, DataJobEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function DataJobEnumFromJSON(json: any): DataJobEnum {
  return DataJobEnumFromJSONTyped(json, false);
}

export function DataJobEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataJobEnum {
  return json as DataJobEnum;
}

export function DataJobEnumToJSON(value?: DataJobEnum | null): any {
  return value as any;
}
